import React, { useState } from 'react';
import styled from 'styled-components';
import { Grid } from '../../../app/StyleGuide';
import ActionableTitleBar from '../../../components/ActionableTitleBar';
import { PrimaryButton, RoundedIconButton } from '../../../components/Buttons';
import { Container } from '../../../components/Layout';
import { SelectOrgList } from '../../org';
import { AllowableOrg } from '../models/allowableOrg';

type SelectOrgForTrainingProps = {
  allowableOrgs: AllowableOrg[];
  currentOrgId: string;
  onOrgSelected: (orgId: string) => void;
  onCreateChurchAccount: () => void;
  onBack: () => void;
};

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: ${Grid._7};
  padding-bottom: ${Grid._10};

  button {
    min-width: 160px;
  }
`;

export const SelectOrgForTraining = ({
  allowableOrgs,
  currentOrgId,
  onOrgSelected,
  onCreateChurchAccount,
  onBack,
}: SelectOrgForTrainingProps) => {
  const [selectedOrgId, setSelectedOrgId] = useState<string>(currentOrgId);

  const sortedOrgs = [...allowableOrgs].sort((a, b) => {
    if (a.id === currentOrgId) return -1;
    if (b.id === currentOrgId) return 1;
    return 0;
  });

  return (
    <div>
      <ActionableTitleBar
        title="Select Your Church"
        subtitle="This church will be used to begin your training"
        leftButton={
          <RoundedIconButton onClick={onBack}>
            <i className="fas fa-arrow-left fa-fw"></i>
            Back
          </RoundedIconButton>
        }
        rightButton={<div />}
      />
      <Container>
        <SelectOrgList
          orgs={sortedOrgs}
          selectedOrgId={selectedOrgId}
          onSelectOrg={setSelectedOrgId}
          onCreateOrg={onCreateChurchAccount}
        />

        <ButtonContainer>
          <PrimaryButton onClick={() => onOrgSelected(selectedOrgId)}>Continue</PrimaryButton>
        </ButtonContainer>
      </Container>
    </div>
  );
};
